import { ifSelectorExist, getElements } from './utils-child';

export const setsTabs = () => {
  const tabContainers = getElements('.findlay-sets-block');

  tabContainers.forEach(container => {
    let tabsContent = container.querySelectorAll(
        '.findlay-sets-block__tabs_image'
      ),
      tabsItems = container.querySelectorAll('.findlay-sets-block__tabs_item'),
      tabsItemsMobile = container.querySelectorAll(
        '.findlay-sets-block__tab_content_mobile'
      );

    if (ifSelectorExist(tabsItems) && ifSelectorExist(tabsContent)) {
      let hideTabContent = () => {
        tabsContent.forEach(element => {
          element.classList.add('hidden');
          element.classList.remove('block');
        });

        tabsItemsMobile.forEach(element => {
          element.classList.add('hidden');
          element.classList.remove('block');
        });

        tabsItems.forEach(element => {
          element.classList.remove('active');
        });
      };

      let showTabContent = (i = 0) => {
        if (ifSelectorExist(tabsContent[i])) {
          tabsContent[i].classList.add('block');
          tabsContent[i].classList.remove('hidden');

          tabsItemsMobile[i].classList.add('block');
          tabsItemsMobile[i].classList.remove('hidden');

          tabsItems[i].classList.add('active');
        }
      };

      tabsItems.forEach((element, i) => {
        element.addEventListener('click', () => {
          hideTabContent();
          showTabContent(i);
        });
      });

      hideTabContent();
      showTabContent();
    }
  });
};
